
import {setServer} from "@/utils/axios";
const request = setServer();
// 用户操作模块类型
export function getEnumUserOperationType(data) {
  return request({
    url: '/base/enum/refer/user/operation/type' ,
    method: 'post',
    data:data
  })
}
// 用户操作功能类型
export function getEnumUserOperationFunType(data) {
  return request({
    url: '/base/enum/refer/user/operation/function/type' ,
    method: 'post',
    data:data
  })
}

// 区域
export function getRegionEnum(data) {
  return request({
    url: '/base/enum/refer/region' ,
    method: 'post',
    data:data
  })
}
// aws区域
export function getAWSRegionEnum(data) {
  return request({
    url: '/base/enum/refer/aws/region' ,
    method: 'post',
    data:data
  })
}

// 服务级别类型
export function getEnumServiceLeave(data) {
  return request({
    url: '/base/enum/refer/rank/type' ,
    method: 'post',
    data:data
  })
}

// 服务优惠方式
export function getEnumServiceDiscount(data) {
  return request({
    url: '/base/enum/refer/server/discount' ,
    method: 'post',
    data:data
  })
}

// 服务类型
export function getEnumServiceType(data) {
  return request({
    url: '/base/enum/refer/server/type' ,
    method: 'post',
    data:data
  })
}

// link状态
export function getEnumLinkTypeEnable(data) {
  return request({
    url: '/base/enum/refer/link/enable' ,
    method: 'post',
    data:data
  })
}

// 客户地区编码
export function getEnumCityRefer(data) {
  return request({
    url: '/base/enum/refer/city/code' ,
    method: 'post',
    data:data
  })
}

// 获取账单支持查询的月份
export function getEnumMonthList(data) {
  return request({
    url: '/base/enum/refer/list/month' ,
    method: 'post',
    data:data
  })
}

// 获取客户级别
export function getEnumLevelList(data) {
  return request({
    url: '/base/enum/refer/customer/level' ,
    method: 'post',
    data:data
  })
}

// 获取账单类型下拉
export function getEnumBillTypeList(data) {
  return request({
    url: '/base/enum/refer/cost/type' ,
    method: 'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/base/enum.js